// @ts-nocheck

import { BasketStatuses } from '../../../types/basket';

/**
 * Return the nextState corresponding to the
 * BASKET_SET_ITEM_ELIGIBLE_FREEBETS action
 *
 * @static
 * @param  {Object} state  The actual state
 * @param  {Object} action The action to reduce
 * @return {Object}        Return the new state.
 */
const basketSetItemEligibleFreebets = (state, action) => {
  const { status } = state;
  const { oddId, eligibleFreebets } = action.payload;
  if (status !== BasketStatuses.PENDING && status !== BasketStatuses.VALIDATED && status !== BasketStatuses.WAITING) {
    return {
      ...state,
      items: {
        ...state.items,
        [oddId]: {
          ...state.items[oddId],
          eligibleFreebets,
        },
      },
    };
  }
  return state;
};

export default basketSetItemEligibleFreebets;
